import React from 'react';
import { Grid } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { useStyles } from './AddSession.styles';
import { YesButton, NoButton } from './ImportSession.styles';
import { useTranslation } from 'react-i18next';
import { ModalWithButtons } from '../ModalWithButtons/ModalWithButtons.component';

interface IImportSession {
  handleImportSession: (close: boolean, next: boolean, isImport: boolean) => void;
}

const ImportSession: React.FC<IImportSession> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const closeHandle = () => {
    props.handleImportSession(true, false, false);
  };

  const yesHandle = () => {
    props.handleImportSession(false, true, true);
  };

  const noHandle = () => {
    props.handleImportSession(false, true, false);
  };

  return (
    <>
      <ModalWithButtons
        xCloseButton={closeHandle}
        open={true}
        size="md"
        title={'Nowa sesja egzaminacyjna'}
        onCancel={closeHandle}
        handleClose={closeHandle}
        isHideBackdrop={true}
      >
        <Grid container justifyContent="center" alignItems="center">
          <div className={classes.checkOutline}>
            <div className={classes.checkOutlineInside}>
              <CheckIcon />
            </div>
          </div>
          <div className={classes.textInline}>
            Dodaj nową <br />
            sesję egzaminacyjną
          </div>
          <hr className={classes.line}></hr>
          <div className={classes.numberCircleInline}>
            <div className={classes.numbersInCirclesOutline}>2</div>
          </div>
          <div className={classes.textOutline}>
            Import danych
            <br />
            sesji egzaminacyjnej
          </div>
        </Grid>
        <Grid container justifyContent="center">
          <div className={classes.middleText}>Czy zaimportować dane sesji egzaminacyjnej?</div>
        </Grid>
        <Grid container justifyContent="center" style={{ marginBottom: '230px' }}>
          <YesButton onClick={yesHandle}>Tak</YesButton>
          <NoButton onClick={noHandle}>Nie</NoButton>
        </Grid>
      </ModalWithButtons>
    </>
  );
};

export default ImportSession;
